var base = require('settings/api/create-token');

Vue.component('spark-create-token', {
    mixins: [base],
    data(){
        return {
            view_modal: false
        };
    },
    methods: {
        /**
         * Display the token to the user.
         */
        showToken(token) {
            this.showingToken = token;

            this.view_modal = true;
        }
    }
});
